import {Injectable} from "@angular/core";
import {ClientConfiguration} from "../configuration/client.config";
import Bugsnag from "@bugsnag/js";
import { Event } from "@bugsnag/core"
import {Login} from "../../login/login";
import {UtilitiesService} from "../utilities.service";
import {Router} from "@angular/router";
import {UserModelState} from "../usermodel/usermodel.state";
import {BrowserAgent} from "../browser/browser.agent";
import {ErrorType, Severity} from "../../constants";

@Injectable()
export class BugsnagService {

    public static readonly NOTIFIER_API_KEY = "4e416793eab9a0941f52b62e05af52ec";
    private static readonly MEMORY_KEY_SET = ["jsHeapSizeLimit", "totalJSHeapSize", "usedJSHeapSize"];
    private isInitialized = false;
    constructor(private config: ClientConfiguration, private loginConfiguration: Login, private router: Router,
                private userModelState: UserModelState, private browserAgent: BrowserAgent) {
        Bugsnag.addOnError((event) => {
            event.context = this.router.url;
            this.addCommonMetadata(event);
        });
        this.isInitialized = true;
    }

    private addCommonMetadata(event: Event) {
        event.addMetadata("state", this.userModelState.userModelDelta);
        event.addMetadata("app", {
            version: UtilitiesService.getVersion(),
            isDebuggerEnabled: this.config.allowDebugKeys,
            isBrowserVersion: this.config.allowBrowserVersion
        });
        event.addMetadata("user", {
            tenantId: this.loginConfiguration.tenantId,
            learnerId: this.loginConfiguration.learnerId
        });
        // not available on all browsers, but still might be useful
        // tslint:disable-next-line:no-string-literal
        if (!!window.performance["memory"]) {
            let memoryObject = {};
            for (let key of BugsnagService.MEMORY_KEY_SET) {
                // tslint:disable-next-line:no-string-literal
                memoryObject[key] = window.performance["memory"][key];
            }
            event.addMetadata("memory", memoryObject);
        }
    }

    public notify(logMsg: string, severity: Severity, type?: ErrorType): void {
        Bugsnag.notify(new Error(logMsg), (event) => {
            let s: "info"|"error"|"warning";
            s = severity === Severity.DEBUG ? "info" : severity;
            event.severity = s;
            if (type) {
                event.context = type;
            } else {
                event.context = this.router.url;
            }
            this.addCommonMetadata(event);
        });
    }
}
